import {useContext, useState} from 'react';

import {useTranslation} from 'react-i18next';

import {Box, Grid, Typography} from '@mui/material';

import {EmpionCollapsibleSection} from '../../../../../../../components/EmpionCollapsibleSection/EmpionCollapsibleSection';
import {UserContext} from '../../../../../../../contexts/UserContext/UserContext';
import {MatchData} from '../../../../../../../types/shared-recruiting-types';
import {CompanyAdminRoleData} from '../../../../../../../types/User';
import {CompanyMatchNotes} from '../../DetailedCardView/CompanyMatchNotes';
import {AssessmentResults} from '../../DetailedCardView/MatchInformation/AssessmentResults';

interface Props {
  match: MatchData;
}

export const MatchSections = ({match}: Props) => {
  const {t} = useTranslation('translation', {keyPrefix: 'matchDetailsPage.matchTabs'});
  const {t: tComments} = useTranslation('translation', {
    keyPrefix: 'companyApplicants.applicantsCard.cardDetails.companyMatchNotes',
  });
  const {currentUser} = useContext(UserContext);
  const companyId = (currentUser?.role?.data as CompanyAdminRoleData)?.companyId;
  const [isMatchAnalysisOpen, setIsMatchAnalysisOpen] = useState(true);
  const [isTestResultsOpen, setIsTestResultsOpen] = useState(false);
  const assessmentScore = match.assessmentResultsInformation?.score;
  const assessmentScoreText = typeof assessmentScore === 'number' ? `${assessmentScore}%` : '-';

  return (
    <Grid container direction='column' gap={1} marginTop={2}>
      <EmpionCollapsibleSection
        title='Match-Analyse'
        variant='secondary'
        collapsible
        open={isMatchAnalysisOpen}
        onToggle={() => setIsMatchAnalysisOpen(prev => !prev)}
      >
        <Box
          sx={{
            fontSize: '15px',
            lineHeight: 1.45,
          }}
          dangerouslySetInnerHTML={{__html: match.matchmakerNotes || ''}}
        />
      </EmpionCollapsibleSection>

      <EmpionCollapsibleSection
        title={t('testResults.title')}
        variant='secondary'
        metaText={assessmentScoreText}
        collapsible
        open={isTestResultsOpen}
        onToggle={() => setIsTestResultsOpen(prev => !prev)}
      >
        <Grid sx={{'& .MuiTypography-root': {fontSize: '15px'}}}>
          <AssessmentResults questions={match.assessmentResultsInformation?.questions} />
        </Grid>
      </EmpionCollapsibleSection>

      <Grid item xs={12} sx={{mt: 1.5}}>
        <Grid sx={{borderTop: '1px solid', borderColor: 'divider', mb: 1.5}} />
        <Typography variant='h2' sx={{mb: 0.5}}>
          {tComments('title')}
        </Typography>
        <Grid sx={{'& .MuiTypography-root': {fontSize: '15px'}}}>
          <CompanyMatchNotes
            companyId={companyId}
            matchId={match.resourceId}
            userId={(currentUser?.role.data as CompanyAdminRoleData).companyAdminId}
            hideTitle
          />
        </Grid>
      </Grid>
    </Grid>
  );
};
